import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-parent-learn-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="learn-skeleton" [class.learn-skeleton--video]="variant() === 'video'">
      @if (variant() === 'video') {
        <div class="learn-skeleton__video" aria-hidden="true"></div>
      } @else {
        <div class="learn-skeleton__line learn-skeleton__line--title" aria-hidden="true"></div>
        <div class="learn-skeleton__line" aria-hidden="true"></div>
        <div class="learn-skeleton__line learn-skeleton__line--short" aria-hidden="true"></div>
      }
    </div>
  `,
  styleUrl: './parent-learn-skeleton.component.scss',
})
export class ParentLearnSkeletonComponent {
  variant = input<'video' | 'quiz'>('video');
}
